/* eslint-disable */

import moment from "moment";

import { get29DaysAgoFromDate_YYYYMMDD, dateToYYYYMMDD, get11MonthsAgoFromDate_YYYYMMDD } from "../utils/date";

import {
  getCurrentUser,
  getAssetsProducing,
  getOrganizations,
  getCountries,
  setStartDate,
  setEndDate,
  setCardsStartDate,
  setCardsEndDate
} from "../actions";

import { ACTION_TYPE } from "./ActionTypes";

import { enums } from "../enums/"

import { getFormValidationStatus } from "../../src/utils/formValidation/ValidationRules";
import { getRequest, postJsonRequest, makeCompleteUrlFromLastPart } from "../utils/requestHelper";
import { getConsumingAssetFrequency } from "../utils/consumingAssetHelper";
import { DEFAULT_CERTIFICATE_STATUS_FILTER_ARRAY } from "../constants/Miscellaneous";
import { ENERGY_MIX_LABEL } from "../constants/Miscellaneous";

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const rad = x => {
  return (x * Math.PI) / 180;
};

const getDistance = (p1, p2) => {
  var R = 6378137; // Earth’s mean radius in meter
  var dLat = rad(p2.lat - p1.lat);
  var dLong = rad(p2.lng - p1.lng);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(rad(p1.lat)) *
    Math.cos(rad(p2.lat)) *
    Math.sin(dLong / 2) *
    Math.sin(dLong / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d; // returns the distance in meter
};

const getDistanceInMeters = (p1, p2) => {
  var R = 6378137; // Earth’s mean radius in meter
  var dLat = rad(p2.lat - p1.lat);
  var dLong = rad(p2.lng - p1.lng);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(rad(p1.lat)) *
    Math.cos(rad(p2.lat)) *
    Math.sin(dLong / 2) *
    Math.sin(dLong / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d; // returns the distance in meter
};

export const reorderProducingAssetsList = (
  assetConsuming,
  sortedAssetsProducing,
  result
) => dispatch => {
  let newAssetsProducingList = reorder(
    sortedAssetsProducing,
    result.source.index,
    result.destination.index
  );

  let currentConsumingAssetProducingSites = newAssetsProducingList.filter(
    pA => {
      return pA.priority >= 0;
    }
  );

  assetConsuming.producingAssets = currentConsumingAssetProducingSites.map(
    (pA, index) => {
      pA.priority = currentConsumingAssetProducingSites.length - index - 1;
      return pA;
    }
  );

  dispatch({
    type: "REORDER_ASSETS_CONSUMING_PROD_ASSETS",
    payload: { assetConsuming, newAssetsProducingList }
  });
  return newAssetsProducingList;
};

export const addProducingAssetToConsumingAsset = (
  assetConsuming,
  assetProducing
) => dispatch => {
  let newProdAssetsList = assetConsuming.producingAssets.map(pAsset => {
    pAsset.priority += 1;

    return pAsset;
  });

  newProdAssetsList.push({ id: assetProducing.id, priority: 0, percentage: 0 });
  assetConsuming.producingAssets = newProdAssetsList;

  dispatch({
    type: "ADD_PROD_ASSET_TO_ASSET_CONSUMING",
    payload: assetConsuming
  });
  return assetConsuming;
};

export const removeProducingAssetFromConsumingAsset = (
  assetConsuming,
  assetProducing
) => dispatch => {
  let prodAssetToRemove = assetConsuming.producingAssets.find(pAsset => {
    return pAsset.id === assetProducing.id;
  });

  let newProdAssetsList = assetConsuming.producingAssets
    .map(pAsset => {
      if (pAsset.priority > prodAssetToRemove.priority) pAsset.priority -= 1;
      return pAsset;
    })
    .filter(pAsset => {
      return pAsset.id !== assetProducing.id;
    });

  assetConsuming.producingAssets = newProdAssetsList;

  dispatch({
    type: "REMOVE_PROD_ASSET_FROM_ASSET_CONSUMING",
    payload: assetConsuming
  });
  return assetConsuming;
};

export const sortAssetsConsuming = (assets, order, orderBy) => dispatch => {
  dispatch({
    type: "SORT_ASSETS_CONSUMING",
    payload: { assets, order, orderBy }
  });
};

export const changePage = page => dispatch => {
  dispatch({ type: "CHANGE_PAGE", payload: { page } });
};

export const changeRowsPerPage = rowsPerPage => dispatch => {
  dispatch({ type: "CHANGE_ROWS_PER_PAGE", payload: { rowsPerPage } });
};

export const archiveAssetConsumingStart = (
  assetConsuming,
  history
) => async dispatch => {

  dispatch({ type: "ARCHIVE_ASSET_CONSUMING_START" });

  try {
    await archiveAssetConsuming(assetConsuming)

    dispatch({ type: "ARCHIVE_ASSET_CONSUMING_SUCCESS" });
    dispatch({ type: "OPEN_SUCCESS", payload: "Asset archived !" });
    
    history.push("/assets/cons/");
  } catch (error) {
    dispatch({ type: "ARCHIVE_ASSET_CONSUMING_FAIL" });
    dispatch({
      type: "OPEN_ERROR",
      payload: "Error archiving assetConsuming"
    });
  }
};

const archiveAssetConsuming = async assetConsuming => {
  return await fetch(
    process.env.REACT_APP_API_URL + "/api/consum/archive/" + assetConsuming._id,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return true;
    })
    .catch(error => error);
};

export const restoreAssetConsumingStart = (
  assetConsuming,
  history
) => async dispatch => {

  dispatch({ type: "RESTORE_ASSET_CONSUMING_START" });

  try {
    await restoreAssetConsuming(assetConsuming)

    dispatch({ type: "RESTORE_ASSET_CONSUMING_SUCCESS" });
    dispatch({ type: "OPEN_SUCCESS", payload: "Asset restored !" });
    
    history.push("/assets/cons/");
  } catch (error) {
    dispatch({ type: "RESTORE_ASSET_CONSUMING_FAIL" });
    dispatch({
      type: "OPEN_ERROR",
      payload: "Error restoring assetConsuming"
    });
  }
};

const restoreAssetConsuming = async assetConsuming => {
  return await fetch(
    process.env.REACT_APP_API_URL + "/api/consum/restore/" + assetConsuming._id,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return true;
    })
    .catch(error => error);
};

export const getConsumingAssets = async () => {
  let url = process.env.REACT_APP_API_URL + "/api/consum" 

  const response = await fetch(url, {
    method: "GET",
    credentials: 'include'
  });
  const json = await response.json();
  return json;
};

export const getConsumingAssetsByCountry = async (countryId) => {
  let url = process.env.REACT_APP_API_URL + "/api/consum/country/" + countryId;

  const response = await fetch(url, {
    method: "GET",
    credentials: 'include'
  });
  const json = await response.json();
  return json;
};


export const getGraphData = async (asset, start, end) => {
  let url = process.env.REACT_APP_API_URL + "/api/graph-data/" + asset.id + "?";
  url += start ? "&start=" + start : "";
  url += end ? "&end=" + end : "";

  return await fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  })
    .then(handleErrors)
    .then(res => res.json())
    .then(result => {
      return result.data;
    })
    .catch(error => {
      console.error(error);
    });
};

export const getBarChartData = async (asset, start, end) => {
  let frequency = getConsumingAssetFrequency(asset)

  let GET_BARCHART_DATA_URL = process.env.REACT_APP_API_URL + "/api/graph-data/barchart/" + asset.id + "?";
  GET_BARCHART_DATA_URL += "&frequency=" + frequency;
  GET_BARCHART_DATA_URL += start ? "&start=" + start : "";
  GET_BARCHART_DATA_URL += end ? "&end=" + end : "";


  return await getRequest(GET_BARCHART_DATA_URL);
};

export const getBarChartOfficialData = async (asset, start, end) => {
  let frequency = getConsumingAssetFrequency(asset)

  let GET_BARCHART_OFFICIAL_DATA_URL = process.env.REACT_APP_API_URL + "/api/graph-data/barchart/official/" + asset.id + "?";
  GET_BARCHART_OFFICIAL_DATA_URL += "&frequency=" + frequency;
  GET_BARCHART_OFFICIAL_DATA_URL += start ? "&start=" + start : "";
  GET_BARCHART_OFFICIAL_DATA_URL += end ? "&end=" + end : "";


  return await getRequest(GET_BARCHART_OFFICIAL_DATA_URL);
};

export const getDoughnutChartData = async (asset, startDate, endDate) => {

  let frequency = getConsumingAssetFrequency(asset)

  let GET_DOUGHNUT_CHART_DATA_URL = process.env.REACT_APP_API_URL + "/api/graph-data/percentage-matched-for-consuming-asset/";

  let statusFilterArray = DEFAULT_CERTIFICATE_STATUS_FILTER_ARRAY;
  let requestBody = {
    consumingAssetObjectId: asset._id,
    startDate,
    endDate,
    statusFilterArray,
    frequency
  }
  return await postJsonRequest(GET_DOUGHNUT_CHART_DATA_URL, requestBody);

};

export const getGraphDataOfficial = async (asset, start, end) => {
  let url = process.env.REACT_APP_API_URL + "/api/graph-data/official/" + asset.id + "?";
  url += start ? "&start=" + start : "";
  url += end ? "&end=" + end : "";

  return await fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  })
    .then(handleErrors)
    .then(res => res.json())
    .then(result => {
      return result.data;
    })
    .catch(error => {
      console.error(error);
    });
};

export const createAssetConsumingStart = (
  asset,
  history,
  sourceHistory
) => async dispatch => {
  let isFormValid = getFormValidationStatus();

  if (!isFormValid) {
    dispatch({ type: "OPEN_ERROR", payload: "Check input errors !" });
  } else {
    if(!asset.organization || !asset.organization._id) {
      dispatch({ type: "OPEN_ERROR", payload: "Please specify an organization !" });
      return;
    }

    dispatch({ type: "CREATE_ASSET_CONSUMING_START" });

    const createdAsset = await createAssetConsuming(
      asset,
      sourceHistory,
      dispatch
    ).catch(error => {
      if (error.msg) createAssetConsumingFail(error.msg, dispatch);
      else createAssetConsumingFail("Error creating asset", dispatch);
    });

    if (createdAsset) {
      createAssetConsumingSuccess(asset.id, history, dispatch);
    }
  }
};

export const createAssetConsumingSuccess = (assetId, history, dispatch) => {
  dispatch({ type: "CREATE_ASSET_CONSUMING_SUCCESS" });
  dispatch({ type: "OPEN_SUCCESS", payload: "New asset created !" });
  history.push("/assets/cons");
};

export const createAssetConsumingFail = (error, dispatch) => {
  dispatch({ type: "CREATE_ASSET_CONSUMING_FAIL" });
  dispatch({ type: "OPEN_ERROR", payload: error });
};

export const updateAssetConsumingStart = (
  asset,
  history,
  sourceHistory
) => async dispatch => {
  if(!asset.organization || !asset.organization._id) {
    dispatch({ type: "OPEN_ERROR", payload: "Please specify an organization !" });
    return;
  }
  
  dispatch({ type: "UPDATE_ASSET_CONSUMING_START" });

  const updatedAsset = await updateAssetConsuming(asset, sourceHistory).catch(
    error => {
      if (error.msg) updateAssetConsumingFail(error.msg, asset.id, dispatch);
      else updateAssetConsumingFail("Error updating asset", asset.id, dispatch);
    }
  );

  if (updatedAsset) {
    updateAssetConsumingSuccess(asset.id, history, dispatch);
  }
};

export const updateAssetConsumingSuccess = (assetId, history, dispatch) => {
  dispatch({ type: "UPDATE_ASSET_CONSUMING_SUCCESS" });
  dispatch({ type: "OPEN_SUCCESS", payload: "Asset Updated !" });
  history.push("/assets/cons");
};

export const updateAssetConsumingFail = (error, assetId, dispatch) => {
  let errorMessage = `${error} .[This message is about asset with id : ${assetId}]`;
  dispatch({ type: "UPDATE_ASSET_CONSUMING_FAIL" });
  dispatch({ type: "OPEN_ERROR", payload: errorMessage });
};

export const getAssetConsumingFormStart = (
  assetId,
  history
) => async dispatch => {
  dispatch({ type: "GET_ASSET_CONSUMING_START" });

  const asset = await getAssetConsuming(assetId);
  await dispatch(getOrganizations())
  await dispatch(getCountries())

  if (asset) {
    const producingAssets = await getAssetsProducing();
    asset.producingAssets = asset.producingAssets.map(prodAsset => {
      let prodAssetFull  = producingAssets.find(producingAsset => producingAsset.id === prodAsset.id)
      prodAssetFull.priority = prodAsset.priority;
      prodAssetFull.percentage = prodAsset.percentage;
      return prodAssetFull;
    });

    dispatch({ type: "GET_ASSET_CONSUMING_SUCCESS", payload: asset });
    return asset;
  } else {
    dispatch({ type: "GET_ASSET_CONSUMING_FAIL", payload: asset });
    history.push("/unauthorized");
    return { status: "unauthorized" };
  }
};

export const getAssetConsuming = async (assetId) => {
  try {
    const GET_CONSUMING_ASSET_URL = `${process.env.REACT_APP_API_URL}/api/consum/${assetId}`;
    let  consumingAsset = await getRequest(GET_CONSUMING_ASSET_URL);
    return consumingAsset;
  }
  catch (err) {
    console.log(err);
  };

};

export const smireNameConsumingChanged = smireName => dispatch => {
  dispatch({
    type: "SMIRE_NAME_CONSUMING_CHANGED",
    payload: smireName
  });
};

export const aggregationPeriodTypeChanged = aggregationPeriodType => dispatch => {
  dispatch({
    type: "AGGREGATION_PERIOD_TYPE_CONSUMING_CHANGED",
    payload: aggregationPeriodType
  });
};

export const aggregationPeriodNumberChanged = aggregationPeriodNumber => dispatch => {
  dispatch({
    type: "AGGREGATION_PERIOD_NUMBER_CONSUMING_CHANGED",
    payload: aggregationPeriodNumber
  });
};

export const timeZoneChanged = timeZone => dispatch => {
  dispatch({ type: "TIME_ZONE_CONSUMING_CHANGED", payload: timeZone });
};

export const consAssetOrganizationChanged = organizationId => dispatch => {
  dispatch({ type: "CONS_ASSET_ORGANIZATION_CHANGED", payload: organizationId });
};

export const consAssetCountryChanged = countryId => dispatch => {
  dispatch({ type: "CONS_ASSET_COUNTRY_CHANGED", payload: countryId });
};

export const nameConsumingChanged = name => dispatch => {
  dispatch({ type: "NAME_CONSUMING_CHANGED", payload: name });
};

export const idChanged = id => dispatch => {
  dispatch({ type: "ASSET_ID_CONSUMING_CHANGED", payload: id });
};

export const SourceChanged = source => dispatch => {
  dispatch({ type: "SOURCE_CONSUMING_CHANGED", payload: source });
};

export const SourceIdChanged = sourceID => dispatch => {
  dispatch({ type: "SOURCE_ID_CONSUMING_CHANGED", payload: sourceID });
};

export const displayPercentageChanged = displayPercentage => dispatch => {
  dispatch({
    type: "DISPLAY_PERCENTAGE_CONSUMING_CHANGED",
    payload: displayPercentage
  });
};

export const matchingPercentageChanged = matchingPercentage => dispatch => {
  dispatch({
    type: "MATCHING_PERCENTAGE_CONSUMING_CHANGED",
    payload: matchingPercentage
  });
};

export const periodNumberConsumingChanged = periodNumber => dispatch => {
  dispatch({
    type: "PERIOD_NUMBER_CONSUMING_CHANGED",
    payload: periodNumber
  });
};

export const periodTypeConsumingChanged = periodType => dispatch => {
  dispatch({
    type: "PERIOD_TYPE_CONSUMING_CHANGED",
    payload: periodType
  });
};

export const displayedNameConsumingChanged = displayedName => dispatch => {
  dispatch({
    type: "DISPLAYED_NAME_CONSUMING_CHANGED",
    payload: displayedName
  });
};

export const locationConsumingChanged = location => dispatch => {
  dispatch({ type: "LOCATION_CONSUMING_CHANGED", payload: location });
};

export const typeOfPublicSupportChanged = typeOfPublicSupport => dispatch => {
  dispatch({
    type: "TYPE_OF_PUBLIC_SUPPORT_CHANGED",
    payload: typeOfPublicSupport
  });
};

export const typeChanged = assetType => dispatch => {
  dispatch({ type: "TYPE_CHANGED", payload: assetType });
};

export const registryComplianceChanged = registryCompliance => dispatch => {
  dispatch({
    type: "REGISTRY_COMPLIANCE_CHANGED",
    payload: registryCompliance
  });
};

export const otherGreenAttributesChanged = otherGreenAttributes => dispatch => {
  dispatch({
    type: "OTHER_GREEN_ATTRIBUTES_CHANGED",
    payload: otherGreenAttributes
  });
};

export const operationalSinceConsumingChanged = timestamp => dispatch => {
  dispatch({ type: "OPERATIONAL_SINCE_CONSUMING_CHANGED", payload: timestamp });
};

export const producingAssetsChanged = producingAssets => dispatch => {
  dispatch({ type: "PRODUCING_ASSETS_CHANGED", payload: producingAssets });
};

const handleErrors = response => {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
};

const handleCatchedErrors = err => {
  throw Error(err);
};

export const startLoading = () => dispatch => {
  dispatch({
    type: ACTION_TYPE.ASSET_CONSUMING.START_LOADING,
  })
};

export const stopLoading = () => dispatch => {
  dispatch({
    type: ACTION_TYPE.ASSET_CONSUMING.STOP_LOADING,
  })
};

export const getAssetOfficialData = async (assetID, startDate, endDate, dispatch) => {
  try {
    
    let startDate_YYYYMMDD = moment(startDate).format('YYYY-MM-DD');
    let endDate_YYYYMMDD = moment(endDate).format('YYYY-MM-DD'); 

    const GET_CO2_OFFICIAL_DATA_FOR_CONSUMING_ASSET_URL = makeCompleteUrlFromLastPart("/api/co2/get-official-data-for-consuming-asset");
    let body = {
      consumingAssetID: assetID,
      startDate_YYYYMMDD: startDate_YYYYMMDD,
      endDate_YYYYMMDD: endDate_YYYYMMDD
    }
    let officialDataForConsumingAsset = await postJsonRequest(GET_CO2_OFFICIAL_DATA_FOR_CONSUMING_ASSET_URL, body);
    
    dispatch({
      type: ACTION_TYPE.ASSET_CONSUMING.GET_OFFICIAL_DATA_FOR_CONSUMING_ASSET,
      payload: {
        officialDataForConsumingAsset: officialDataForConsumingAsset
      }
    });
  } catch (error) {
    console.error(`Cannot obtain official data for consuming asset : ${error}`)
  }
};

export const getUserTotalYearToDateAvoidedCO2 = async (dispatch) => {
  try {
    let userTotalYearToDateAvoidedCO2 = await fetch(
      `${process.env.REACT_APP_API_URL}/api/co2/get-user-total-year-to-date-avoided-co2`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      }
    ).then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data.userTotalYearToDateAvoidedCO2;
    })
    .catch(error => {
      console.error(error);
    });

    dispatch({
      type: ACTION_TYPE.ASSET_CONSUMING.GET_USER_YEAR_TO_DATE_AVOIDED_CO2_SUCCESS,
      payload: {
        userTotalYearToDateAvoidedCO2: userTotalYearToDateAvoidedCO2
      }
    });
  } catch (error) {
    console.error(`Cannot obtain user yearly total avoided co2 : ${error}`)
  }
};

export const getConsumingAssetTotalYearToDateAvoidedCO2 = async (assetID, dispatch)  => {
  try {
    let consumingAssetTotalYearToDateAvoidedCO2 = await fetch(
      `${process.env.REACT_APP_API_URL}/api/co2/get-asset-total-year-to-date-avoided-co2`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          consumingAssetID: assetID
        }),
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      }
    ).then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data.consumingAssetTotalYearToDateAvoidedCO2;
    })
    .catch(error => {
      console.error(error);
    });

    dispatch({
      type: ACTION_TYPE.ASSET_CONSUMING.GET_CONSUMING_ASSET_YEAR_TO_DATE_AVOIDED_CO2_SUCCESS,
      payload: {
        consumingAssetTotalYearToDateAvoidedCO2: consumingAssetTotalYearToDateAvoidedCO2
      }
    });
  } catch (error) {
    console.error(`Cannot obtain consuming asset yearly total avoided co2 : ${error}`)
  }
};

export const getDashboardData = async sender => {
  try {
    const consumingAssets = await getConsumingAssets(); 
    const currentUser = await getCurrentUser();
    const adminRole = currentUser.roles.find(role => {
      return role === "admin";
    });

    const hasAdminRole = adminRole ? true : false;
    let authorizedConsumingAssets = consumingAssets;
    const producingAssets = await getAssetsProducing();
    let totalAvoidedCo2Month = 0;
    let totalAvoidedCo2YTD = 0;

    let totalGreenElectricityMonth = 0;
    let totalGreenElectricityYTD = 0;

    let averageDistanceMonth = 0;
    let averageDistanceYTD = 0;

    let averagePercentageMonthLabels = [];
    let averagePercentageLastDayLabels = [];
    let averagePercentageMonthData = [];
    let averagePercentageLastDayData = [];
    let yearToDateAssetsData = [];

    for (const asset of authorizedConsumingAssets) {
      let assetProducingSites = asset.producingAssets.map(assetPa => {
        const assetRetrieved = producingAssets.find(pA => {
          return assetPa.id === pA.id;
        });
        return assetRetrieved;
      });
      asset.producingAssets = assetProducingSites.map(pA => {
        const offChainProdAsset = assetProducingSites.find(pAOff => {
          return pAOff.id === pA.id;
        });
        if (offChainProdAsset) {
          pA.duplicateOfAssetId = offChainProdAsset.duplicateOfAssetId;
        }

        return pA;
      });

      let currentYear = moment().format("YYYY");
      let startDate = moment()
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      let firstJanuary = moment(currentYear + "-01-01", "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      );
      let today = moment().format("YYYY-MM-DD");

      const graphData = await getGraphData(asset, startDate, today);

      if (graphData.doughnutChartData.length > 0) {
        producingAssets.map(pAsset => {

          const selectedProdAsset = asset.producingAssets.find(assetP => {
            return assetP.id === pAsset.id;
          });

          if (selectedProdAsset) {
            let pAssetIndex = averagePercentageMonthLabels.indexOf(
              pAsset.displayedName
            );
            if (pAssetIndex < 0) {
              averagePercentageMonthLabels.push(pAsset.displayedName);
              pAssetIndex = averagePercentageMonthLabels.length - 1;
            }

            let dataIndex = graphData.doughnutChartLabels.indexOf(
              pAsset.displayedName
            );

            if (typeof averagePercentageMonthData[pAssetIndex] === "undefined") {

              averagePercentageMonthData[pAssetIndex] =
                graphData.doughnutChartData[dataIndex];
            } else {

              averagePercentageMonthData[pAssetIndex] =
                averagePercentageMonthData[pAssetIndex] +
                graphData.doughnutChartData[dataIndex];
            }

            if (typeof averagePercentageLastDayData[pAssetIndex] === "undefined") {

              if (graphData.doughnutChartLastDayData) {
                averagePercentageLastDayData[pAssetIndex] =
                  graphData.doughnutChartLastDayData[dataIndex];
              } else {
                averagePercentageLastDayData[pAssetIndex] = null;
              }
            } else {
              if (
                typeof graphData.doughnutChartLastDayData === "undefined"
              ) {
              } else {
                averagePercentageLastDayData[pAssetIndex] =
                  averagePercentageLastDayData[pAssetIndex] +
                  graphData.doughnutChartLastDayData[dataIndex];
              }
            }
          }
        });

        //Put the % for the 'Energy Mix'

        const DATA_MIX_INDEX = graphData.doughnutChartLabels.indexOf(
          "Energy Mix"
        );

        let pAssetMixIndex = averagePercentageMonthLabels.indexOf("Energy Mix");
        if (pAssetMixIndex < 0) {
          averagePercentageMonthLabels.push("Energy Mix");
          pAssetMixIndex = averagePercentageMonthLabels.length - 1;
        }

        if (typeof averagePercentageMonthData[pAssetMixIndex] === "undefined") {
          // does not exist
          averagePercentageMonthData[pAssetMixIndex] =
            graphData.doughnutChartData[DATA_MIX_INDEX];
        } else {
          // does exist
          averagePercentageMonthData[pAssetMixIndex] =
            averagePercentageMonthData[pAssetMixIndex] +
            graphData.doughnutChartData[DATA_MIX_INDEX];
        }

        if (typeof averagePercentageLastDayData[pAssetMixIndex] === "undefined") {
          // does not exist
          if (graphData.doughnutChartLastDayData) {
            averagePercentageLastDayData[pAssetMixIndex] =
              graphData.doughnutChartLastDayData[DATA_MIX_INDEX];
          } else {
            averagePercentageLastDayData[pAssetMixIndex] = null;
          }
        } else {
          // does exist
          if (typeof graphData.doughnutChartLastDayData === "undefined") {
            averagePercentageLastDayData[pAssetMixIndex] = 0;
          } else {
            averagePercentageLastDayData[pAssetMixIndex] =
              averagePercentageLastDayData[pAssetMixIndex] +
              graphData.doughnutChartLastDayData[DATA_MIX_INDEX];
          }
        }

        const yearToDateDataOnChain = await getGraphData(
          asset,
          firstJanuary,
          today
        );
        yearToDateAssetsData.push(yearToDateDataOnChain)

        totalAvoidedCo2Month += graphData.totalAvoidedCo2;
        totalAvoidedCo2YTD += yearToDateDataOnChain.totalAvoidedCo2;

        totalGreenElectricityMonth += graphData.totalEnergyMatched;
        totalGreenElectricityYTD += yearToDateDataOnChain.totalEnergyMatched;

        let assetAverageDistanceMonth = 0;
        let assetAverageDistanceYTD = 0;

        const assetConsumingLatLng = {
          lat: parseFloat(asset.gpsLatitude),
          lng: parseFloat(asset.gpsLongitude)
        };

        const prodAssetsRatiosMonth = graphData.doughnutChartData.map(
          data => data
        );

        prodAssetsRatiosMonth.pop();

        const prodAssetsRatiosYTD = yearToDateDataOnChain.doughnutChartData.map(
          data => data
        );

        prodAssetsRatiosYTD.pop();

        let totalRatioMonth = 0;
        let totalRatioYTD = 0;

        prodAssetsRatiosMonth.map(prodAssetRatio => {
          totalRatioMonth += prodAssetRatio;
          return true;
        });

        prodAssetsRatiosYTD.map(prodAssetRatio => {
          totalRatioYTD += prodAssetRatio;
          return true;
        });

        const ratiosProductionMonth = prodAssetsRatiosMonth.map(ratio => {
          return ratio / totalRatioMonth;
        });

        const ratiosProductionYTD = prodAssetsRatiosYTD.map(ratio => {
          return ratio / totalRatioYTD;
        });

        const assetsWithDistanceAndTotalEnergyMonth = assetProducingSites
          .filter(pA => !pA.isFake)
          .map((asset, index) => {
            const assetWithDistanceAndTotalEnergy = {
              id: asset.id,
              distance: 0,
              energyRatio: 0
            };

            const assetLatLng = {
              lat: parseFloat(asset.gpsLatitude),
              lng: parseFloat(asset.gpsLongitude)
            };


            assetWithDistanceAndTotalEnergy.distance = getDistance(
              assetConsumingLatLng,
              assetLatLng
            );
            assetWithDistanceAndTotalEnergy.energyRatio =
              ratiosProductionMonth[index];

            return assetWithDistanceAndTotalEnergy;
          });

        const assetsWithDistanceAndTotalEnergyYTD = assetProducingSites
          .filter(pA => !pA.isFake)
          .map((asset, index) => {
            const assetWithDistanceAndTotalEnergy = {
              id: asset.id,
              distance: 0,
              energyRatio: 0
            };

            const assetLatLng = {
              lat: parseFloat(asset.gpsLatitude),
              lng: parseFloat(asset.gpsLongitude)
            };

            assetWithDistanceAndTotalEnergy.distance = getDistance(
              assetConsumingLatLng,
              assetLatLng
            );
            assetWithDistanceAndTotalEnergy.energyRatio =
              ratiosProductionYTD[index];

            return assetWithDistanceAndTotalEnergy;
          });

        assetsWithDistanceAndTotalEnergyMonth.map(asset => {
          assetAverageDistanceMonth += asset.distance * asset.energyRatio;
        });

        assetsWithDistanceAndTotalEnergyYTD.map(asset => {
          assetAverageDistanceYTD += asset.distance * asset.energyRatio;
        });

        averageDistanceMonth +=
          graphData.totalEnergyMatched * assetAverageDistanceMonth;
        averageDistanceYTD +=
          yearToDateDataOnChain.totalEnergyMatched * assetAverageDistanceYTD;
      }

      averagePercentageMonthData = averagePercentageMonthData.map(data => {
        return data / averagePercentageMonthData.length;
      });

      averagePercentageLastDayData = averagePercentageLastDayData.map(data => {
        return data / averagePercentageLastDayData.length;
      });
    }

    let totalDoughnutChart = 0
    for (const percentage of averagePercentageMonthData) {
      totalDoughnutChart += percentage
    }
    averagePercentageMonthData = averagePercentageMonthData.map(data => {
      return 100 * data / totalDoughnutChart
    })

    return {
      dashboardTotalAvoidedCo2Month: totalAvoidedCo2Month,
      dashboardTotalAvoidedCo2YTD: totalAvoidedCo2YTD,
      dashboardTotalGreenElectricityMonth: totalGreenElectricityMonth,
      dashboardTotalGreenElectricityYTD: totalGreenElectricityYTD,
      dashboardAverageDistanceMonth:
        totalGreenElectricityMonth > 0
          ? averageDistanceMonth / totalGreenElectricityMonth
          : 0,
      dashboardAverageDistanceYTD:
        totalGreenElectricityYTD > 0
          ? averageDistanceYTD / totalGreenElectricityYTD
          : 0,
      dashboardAveragePercentageMonthLabels: averagePercentageMonthLabels,
      dashboardAveragePercentageMonthData: averagePercentageMonthData,
      dashboardAveragePercentageLastDayLabels: averagePercentageMonthLabels,
      dashboardAveragePercentageLastDayData: averagePercentageLastDayData,
      yearToDateAssetsData: yearToDateAssetsData,
      userConsumingAssets: hasAdminRole ? consumingAssets : authorizedConsumingAssets
    }
  } catch (error) {
    handleCatchedErrors(error);
  }
};

export const getDashboardDataOfficial = async sender => {
  try {

    const consumingAssets = await getConsumingAssets();

    const currentUser = await getCurrentUser();

    const adminRole = currentUser.roles.find(role => {
      return role === "admin";
    });

    const hasAdminRole = adminRole ? true : false;
    let authorizedConsumingAssets = consumingAssets;

    if (!hasAdminRole) {
      authorizedConsumingAssets = consumingAssets
        .filter(consAsset => {
          return !consAsset.isFake;
        })
        .filter(consAsset => {
          const filteredAsset = currentUser.user_metadata.consumingSites.find(consSiteId => {
            return parseInt(consSiteId) === parseInt(consAsset.id);
          });
          return filteredAsset !== undefined ? true : false;
        });
    }

    const producingAssets = await getAssetsProducing();
    let totalAvoidedCo2Month = 0;
    let totalAvoidedCo2YTD = 0;

    let totalGreenElectricityMonth = 0;
    let totalGreenElectricityYTD = 0;

    let averageDistanceMonth = 0;
    let averageDistanceYTD = 0;

    let averagePercentageMonthLabels = [];
    let averagePercentageLastDayLabels = [];
    let averagePercentageMonthData = [];
    let averagePercentageLastDayData = [];
    let yearToDateAssetsData = [];

    for (const asset of authorizedConsumingAssets) {

      let assetProducingSites = asset.producingAssets.map(assetPa => {
        const assetRetrieved = producingAssets.find(pA => {
          return assetPa.id === pA.id;
        });
        return assetRetrieved;
      });

      asset.producingAssets = assetProducingSites.map(pA => {
        const offChainProdAsset = assetProducingSites.find(pAOff => {
          return pAOff.id === pA.id;
        });
        if (offChainProdAsset) {
          pA.duplicateOfAssetId = offChainProdAsset.duplicateOfAssetId;
        }

        return pA;
      });

      let currentYear = moment().format("YYYY");
      let startDate = moment()
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      let firstJanuary = moment(currentYear + "-01-01", "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      );
      let today = moment().format("YYYY-MM-DD");

      const graphData = await getGraphData(asset, startDate, today);

      producingAssets.map(pAsset => {

        const selectedProdAsset = asset.producingAssets.find(assetP => {
          return assetP.id === pAsset.id;
        });

        if (selectedProdAsset) {
          let pAssetIndex = averagePercentageMonthLabels.indexOf(
            pAsset.displayedName
          );
          if (pAssetIndex < 0) {
            averagePercentageMonthLabels.push(pAsset.displayedName);
            pAssetIndex = averagePercentageMonthLabels.length - 1;
          }

          let dataIndex = graphData.doughnutChartLabels.indexOf(
            pAsset.displayedName
          );

          if (typeof averagePercentageMonthData[pAssetIndex] === "undefined") {

            averagePercentageMonthData[pAssetIndex] =
              graphData.doughnutChartData[dataIndex];
          } else {

            averagePercentageMonthData[pAssetIndex] =
              averagePercentageMonthData[pAssetIndex] +
              graphData.doughnutChartData[dataIndex];
          }

          if (typeof averagePercentageLastDayData[pAssetIndex] === "undefined") {

            if (graphData.doughnutChartLastDayData) {
              averagePercentageLastDayData[pAssetIndex] =
                graphData.doughnutChartLastDayData[dataIndex];
            } else {
              averagePercentageLastDayData[pAssetIndex] = null;
            }
          } else {
            if (
              typeof graphData.doughnutChartLastDayData === "undefined"
            ) {
            } else {
              averagePercentageLastDayData[pAssetIndex] =
                averagePercentageLastDayData[pAssetIndex] +
                graphData.doughnutChartLastDayData[dataIndex];
            }
          }
        }
      });

      //Put the % for the 'Energy Mix'

      const DATA_MIX_INDEX = graphData.doughnutChartLabels.indexOf(
        "Energy Mix"
      );

      let pAssetMixIndex = averagePercentageMonthLabels.indexOf("Energy Mix");
      if (pAssetMixIndex < 0) {
        averagePercentageMonthLabels.push("Energy Mix");
        pAssetMixIndex = averagePercentageMonthLabels.length - 1;
      }

      if (typeof averagePercentageMonthData[pAssetMixIndex] === "undefined") {
        // does not exist
        averagePercentageMonthData[pAssetMixIndex] =
          graphData.doughnutChartData[DATA_MIX_INDEX];
      } else {
        // does exist
        averagePercentageMonthData[pAssetMixIndex] =
          averagePercentageMonthData[pAssetMixIndex] +
          graphData.doughnutChartData[DATA_MIX_INDEX];
      }

      if (typeof averagePercentageLastDayData[pAssetMixIndex] === "undefined") {
        // does not exist
        if (graphData.doughnutChartLastDayData) {
          averagePercentageLastDayData[pAssetMixIndex] =
            graphData.doughnutChartLastDayData[DATA_MIX_INDEX];
        } else {
          averagePercentageLastDayData[pAssetMixIndex] = null;
        }
      } else {
        // does exist
        if (typeof graphData.doughnutChartLastDayData === "undefined") {
          averagePercentageLastDayData[pAssetMixIndex] = 0;
        } else {
          averagePercentageLastDayData[pAssetMixIndex] =
            averagePercentageLastDayData[pAssetMixIndex] +
            graphData.doughnutChartLastDayData[DATA_MIX_INDEX];
        }
      }

      const yearToDateDataOnChain = await getGraphDataOfficial(
        asset,
        firstJanuary,
        today
      );

      yearToDateAssetsData.push(yearToDateDataOnChain)

      totalAvoidedCo2Month += graphData.totalAvoidedCo2;
      totalAvoidedCo2YTD += yearToDateDataOnChain.totalAvoidedCo2;

      totalGreenElectricityMonth += graphData.totalEnergyMatched;
      totalGreenElectricityYTD += yearToDateDataOnChain.totalEnergyMatched;

      let assetAverageDistanceMonth = 0;
      let assetAverageDistanceYTD = 0;

      const assetConsumingLatLng = {
        lat: parseFloat(asset.gpsLatitude),
        lng: parseFloat(asset.gpsLongitude)
      };

      const prodAssetsRatiosMonth = graphData.doughnutChartData.map(
        data => data
      );

      prodAssetsRatiosMonth.pop();

      const prodAssetsRatiosYTD = yearToDateDataOnChain.doughnutChartData.map(
        data => data
      );

      prodAssetsRatiosYTD.pop();

      let totalRatioMonth = 0;
      let totalRatioYTD = 0;

      prodAssetsRatiosMonth.map(prodAssetRatio => {
        totalRatioMonth += prodAssetRatio;
        return true;
      });

      prodAssetsRatiosYTD.map(prodAssetRatio => {
        totalRatioYTD += prodAssetRatio;
        return true;
      });

      const ratiosProductionMonth = prodAssetsRatiosMonth.map(ratio => {
        return ratio / totalRatioMonth;
      });

      const ratiosProductionYTD = prodAssetsRatiosYTD.map(ratio => {
        return ratio / totalRatioYTD;
      });

      const assetsWithDistanceAndTotalEnergyMonth = assetProducingSites
        .filter(pA => !pA.isFake)
        .map((asset, index) => {
          const assetWithDistanceAndTotalEnergy = {
            id: asset.id,
            distance: 0,
            energyRatio: 0
          };

          const assetLatLng = {
            lat: parseFloat(asset.gpsLatitude),
            lng: parseFloat(asset.gpsLongitude)
          };

          assetWithDistanceAndTotalEnergy.distance = getDistance(
            assetConsumingLatLng,
            assetLatLng
          );
          assetWithDistanceAndTotalEnergy.energyRatio =
            ratiosProductionMonth[index];

          return assetWithDistanceAndTotalEnergy;
        });

      const assetsWithDistanceAndTotalEnergyYTD = assetProducingSites
        .filter(pA => !pA.isFake)
        .map((asset, index) => {
          const assetWithDistanceAndTotalEnergy = {
            id: asset.id,
            distance: 0,
            energyRatio: 0
          };

          const assetLatLng = {
            lat: parseFloat(asset.gpsLatitude),
            lng: parseFloat(asset.gpsLongitude)
          };

          assetWithDistanceAndTotalEnergy.distance = getDistance(
            assetConsumingLatLng,
            assetLatLng
          );
          assetWithDistanceAndTotalEnergy.energyRatio =
            ratiosProductionYTD[index];

          return assetWithDistanceAndTotalEnergy;
        });

      assetsWithDistanceAndTotalEnergyMonth.map(asset => {
        assetAverageDistanceMonth += asset.distance * asset.energyRatio;
      });

      assetsWithDistanceAndTotalEnergyYTD.map(asset => {
        assetAverageDistanceYTD += asset.distance * asset.energyRatio;
      });

      averageDistanceMonth +=
        graphData.totalEnergyMatched * assetAverageDistanceMonth;
      averageDistanceYTD +=
        yearToDateDataOnChain.totalEnergyMatched * assetAverageDistanceYTD;
    }

    averagePercentageMonthData = averagePercentageMonthData.map(data => {
      return data / averagePercentageMonthData.length;
    });

    averagePercentageLastDayData = averagePercentageLastDayData.map(data => {
      return data / averagePercentageLastDayData.length;
    });

    return {
      dashboardTotalAvoidedCo2Month: totalAvoidedCo2Month,
      dashboardTotalAvoidedCo2YTD: totalAvoidedCo2YTD,
      dashboardTotalGreenElectricityMonth: totalGreenElectricityMonth,
      dashboardTotalGreenElectricityYTD: totalGreenElectricityYTD,
      dashboardAverageDistanceMonth:
        totalGreenElectricityMonth > 0
          ? averageDistanceMonth / totalGreenElectricityMonth
          : 0,
      dashboardAverageDistanceYTD:
        totalGreenElectricityYTD > 0
          ? averageDistanceYTD / totalGreenElectricityYTD
          : 0,
      dashboardAveragePercentageMonthLabels: averagePercentageMonthLabels,
      dashboardAveragePercentageMonthData: averagePercentageMonthData,
      dashboardAveragePercentageLastDayLabels: averagePercentageMonthLabels,
      dashboardAveragePercentageLastDayData: averagePercentageLastDayData,
      yearToDateAssetsData: yearToDateAssetsData,
      userConsumingAssets: hasAdminRole ? consumingAssets : authorizedConsumingAssets
    }
  } catch (error) {
    handleCatchedErrors(error);
  }
};

export const getBarChartAssetsDataPerYear = async (year) => {
  const authorizedConsumingAssets = await getConsumingAssets();

  let barChartAssetsData = [];

  let statusFilterArray = DEFAULT_CERTIFICATE_STATUS_FILTER_ARRAY;

  for (const asset of authorizedConsumingAssets) {
    let frequency = getConsumingAssetFrequency(asset);
    let lastMatchedCertificateStartDate = await getLastMatchedStartDateForConsumingAsset(asset, statusFilterArray);
    let lastMatchedDay = moment(lastMatchedCertificateStartDate);
    if(frequency === enums.FrequencyTypes.HOURLY) {
      lastMatchedDay =  moment.tz(lastMatchedCertificateStartDate, asset.momentTimezone);
    }

    let firstJanuary = moment(year + "-01-01", "YYYY-MM-DD").format("YYYY-MM-DD");

    let december31st = moment(year + "-12-31", "YYYY-MM-DD").format("YYYY-MM-DD");;

    let endDate = lastMatchedDay.format('YYYY') === year ? lastMatchedDay.format('YYYY-MM-DD') : december31st;

    const barChartData = await getBarChartOfficialData(
      asset,
      firstJanuary,
      endDate 
    );

    barChartAssetsData.push(barChartData);
  }
  
  return barChartAssetsData;
};

export const dashboardStart = () => async dispatch => {
  dispatch({ type: "DASHBOARD_START" });
  
  try {
    await getUserTotalYearToDateAvoidedCO2(dispatch);
  } catch (error) {
    console.error(error)
  }

  let dashboardData = await getDashboardData();
  dispatch({ type: "GET_ASSETS_CONSUMING_SUCCESS", payload: dashboardData.userConsumingAssets });

  dispatch({
    type: "DASHBOARD_SUCCESS",
    payload: dashboardData
  });
};

export const getAssetsConsumingStart = sender => async dispatch => {
  dispatch({ type: "GET_ASSETS_CONSUMING_START" });
  let consumingAssets = await getConsumingAssets();
  dispatch({ type: "GET_ASSETS_CONSUMING_SUCCESS", payload: consumingAssets });
  return consumingAssets;
};

export const getOffchainConsSources = async type => {
  try {
    let response = await fetch(
      process.env.REACT_APP_API_URL + "/api/source/" + type,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      }
    );

    handleErrors(response);

    let data = await response.json();

    return data;
  } catch (error) {
    handleCatchedErrors(error);
  }
};

export const getOffchainConsSourceHistory = async assetId => {
  try {
    let response = await fetch(
      process.env.REACT_APP_API_URL + "/api/consum/sourceHistory/" + assetId,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      }
    );

    handleErrors(response);

    let data = await response.json();

    return data;
  } catch (error) {
    handleCatchedErrors(error);
  }
};

const fetchOffchainMaxProducingAssetId = async () => {
  try {
    let response = await fetch(
      process.env.REACT_APP_API_URL + "/api/consum/maxId",
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      }
    );

    handleErrors(response);

    let data = await response.json();

    return data;
  } catch (error) {
    handleCatchedErrors(error);
  }
};

const checkTotalAllocatedPercentage = async assetConsuming => {
  try {
    let response = await fetch(
      process.env.REACT_APP_API_URL +
      "/api/consum/checkPercentageAllocation/",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        },
        body: JSON.stringify({ consumingAsset : assetConsuming })
      }
    );

    handleErrors(response);

    let data = await response.json();

    return data;
  } catch (error) {
    handleCatchedErrors(error);
  }
};

const createAssetConsuming = async (assetConsuming, sourceHistory) => {
  let check = await checkTotalAllocatedPercentage(assetConsuming);
  let validAllocatedPercentage = check.status;

  if (!validAllocatedPercentage) {
    const invalidProdAsset = check.invalidProdAsset;
    const maxAllowedPercentage = check.maxAllowedPercentage;

    throw {
      msg:
        "Allocated percentage for asset " +
        invalidProdAsset +
        " exceeds maximum allowed (" +
        maxAllowedPercentage +
        "%)",

      error: new Error()
    };
  }

  assetConsuming.sourceHistory = sourceHistory;

  assetConsuming.periodType = assetConsuming.periodType
    ? assetConsuming.periodType
    : "";

  assetConsuming.aggregationPeriodType = assetConsuming.aggregationPeriodType
    ? assetConsuming.aggregationPeriodType
    : "";

  assetConsuming.momentTimezone = assetConsuming.momentTimezone
    ? assetConsuming.momentTimezone
    : "";
  assetConsuming.producingAssets = assetConsuming.producingAssets.map(
    pAsset => {
      pAsset.priority = pAsset.priority;
      return pAsset;
    }
  );

  let id = await fetchOffchainMaxProducingAssetId();

  id = id + 1;
  assetConsuming.id = id;
  assetConsuming.active = true;

  const json = JSON.stringify(assetConsuming);
  try {
    let response = await fetch(
      process.env.REACT_APP_API_URL + "/api/consum/add",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        },
        body: json
      }
    );

    handleErrors(response);

    let data = await response.json();

    return data;
  } catch (error) {
    handleCatchedErrors(error);
  }
};

const updateAssetConsuming = async (assetConsuming, sourceHistory) => {
  let check = await checkTotalAllocatedPercentage(assetConsuming);
  let validAllocatedPercentage = check.status;

  if (!validAllocatedPercentage) {
    const invalidProdAsset = check.invalidProdAsset;
    const maxAllowedPercentage = check.maxAllowedPercentage;

    throw {
      msg:
        "Allocated percentage for asset " +
        invalidProdAsset +
        " exceeds maximum allowed (" +
        maxAllowedPercentage +
        "%)",

      error: new Error()
    };
  }

  assetConsuming.sourceHistory = sourceHistory;

  assetConsuming.producingAssets = assetConsuming.producingAssets.map(
    pAsset => {
      pAsset.priority = parseInt(pAsset.priority, 10);
      return pAsset;
    }
  );

  const json = JSON.stringify(assetConsuming);

  try {
    let response = await fetch(
      process.env.REACT_APP_API_URL + "/api/consum/" + assetConsuming._id,
      {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        },
        body: json
      }
    );

    handleErrors(response);

    let data = await response.json();

    return data;
  } catch (error) {
    handleCatchedErrors(error);
  }
};

export const toggleCo2DetailsDialog = () => dispatch => {
  dispatch({ type: "TOGGLE_CO2_DETAILS" });
};

export const setCustomButtonPressed = () => dispatch => { 
  dispatch({ type: ACTION_TYPE.ASSET_CONSUMING.CUSTOM_BUTTON_PRESSED });
};

export const setThirtyDayButtonPressed = () => dispatch => {
  dispatch({ type: ACTION_TYPE.ASSET_CONSUMING.THIRTY_DAYS_BUTTON_PRESSED });
};

export const setTwelveMonthsButtonPressed = () => dispatch => {
  dispatch({ type: ACTION_TYPE.ASSET_CONSUMING.TWELVE_MONTHS_BUTTON_PRESSED });
};

export const setOneYearButtonPressed = () => dispatch => {
  dispatch({ type: ACTION_TYPE.ASSET_CONSUMING.ONE_YEAR_BUTTON_PRESSED });
};

export const resetCardsUnderlyingValues = () => async dispatch => {
  dispatch({ type: ACTION_TYPE.ASSET_CONSUMING.RESET_CARD_UNDERLYING_VALUES });
};

export const resetGraphData = () => async dispatch => {
  dispatch({ type: ACTION_TYPE.ASSET_CONSUMING.RESET_GRAPH_DATA });
};

export const resetCurrentAssetConsuming = () => async dispatch => {
  dispatch({ type: "RESET_ASSET_CONSUMING" });
};

export const getConsumingAssetFrontEndData = async(consumingAsset, startDate, endDate, statusFilterArray) => {
  const GET_CONSUMING_ASSET_FRONT_END_DATA = makeCompleteUrlFromLastPart("/api/front-end/get-consuming-asset-front-end-data-co2-energy-average-distance");
  
  let frequency = getConsumingAssetFrequency(consumingAsset)

  let body = {
    assetID: consumingAsset.assetID,
    startDate: startDate,
    endDate: endDate,
    statusFilterArray: statusFilterArray,
    certificateFrequencyFilter: frequency
  }
  let consumingAssetFrontEndData = await postJsonRequest(GET_CONSUMING_ASSET_FRONT_END_DATA, body);

  return consumingAssetFrontEndData;
}

export const getAssetConsumingStart = (
  assetId,
  history
) => async dispatch => {
  const asset = await getAssetConsuming(assetId, history, dispatch);
  console.log({asset, assetId})

  if (asset && asset["producingAssets"]) {
    try {
      const producingAssets = await getAssetsProducing();
      console.log({producingAssets})
      asset["producingAssets"] = asset["producingAssets"].map(prodAsset => {
        let prodAssetFull  = producingAssets.find(producingAsset => producingAsset.id === prodAsset.id)
        prodAssetFull.priority = prodAsset.priority;
        prodAssetFull.percentage = prodAsset.percentage;
        return prodAssetFull;
      });

      dispatch({ type: "GET_ASSET_CONSUMING_SUCCESS", payload: asset });

      let statusFilterArray = DEFAULT_CERTIFICATE_STATUS_FILTER_ARRAY;

      let frequency = getConsumingAssetFrequency(asset)
      
      if( frequency === enums.FrequencyTypes.MONTHLY) {
        dispatch({ type: ACTION_TYPE.ASSET_CONSUMING.TWELVE_MONTHS_BUTTON_PRESSED });
      } else {
        dispatch({ type: ACTION_TYPE.ASSET_CONSUMING.THIRTY_DAYS_BUTTON_PRESSED });
      }

      // Get last matched day
      let lastMatchedCertificateStartDate;
      try {
        lastMatchedCertificateStartDate = await getLastMatchedStartDateForConsumingAsset(asset, statusFilterArray);
      } catch(error) {
        // If most recent matching date could not be retrieved, consider lastMatchedCertificateStartDate to be current date
        lastMatchedCertificateStartDate = moment();
      }
      
      let lastMatchedDay = moment(lastMatchedCertificateStartDate).format("YYYY-MM-DD")

      let equivalentCardsStartDate = get29DaysAgoFromDate_YYYYMMDD(lastMatchedCertificateStartDate);
      let equivalentCardsEndDate = dateToYYYYMMDD(lastMatchedCertificateStartDate);

      let barChartStartDate = get29DaysAgoFromDate_YYYYMMDD(lastMatchedCertificateStartDate);
      let barChartEndDate = dateToYYYYMMDD(lastMatchedCertificateStartDate);
      

      let doughnutChartStartDate = get29DaysAgoFromDate_YYYYMMDD(lastMatchedCertificateStartDate);
      let doughnutChartEndDate = dateToYYYYMMDD(lastMatchedCertificateStartDate);

      //12 months ago and last month for cards on a monthly frequency
      if(frequency === enums.FrequencyTypes.MONTHLY) {
        barChartStartDate = get11MonthsAgoFromDate_YYYYMMDD(lastMatchedCertificateStartDate);
        doughnutChartStartDate = get11MonthsAgoFromDate_YYYYMMDD(lastMatchedCertificateStartDate);
        equivalentCardsStartDate = dateToYYYYMMDD(lastMatchedCertificateStartDate);
      } else if(frequency === enums.FrequencyTypes.HOURLY) {
        lastMatchedDay =  moment.tz(lastMatchedCertificateStartDate, asset.momentTimezone).format("YYYY-MM-DD");
        lastMatchedCertificateStartDate = lastMatchedDay;
        equivalentCardsEndDate = barChartEndDate = doughnutChartEndDate = lastMatchedCertificateStartDate;
        let startDate_29DaysAgo = moment.tz(lastMatchedCertificateStartDate, asset.momentTimezone).subtract(29, "days").format("YYYY-MM-DD");
        equivalentCardsStartDate = barChartStartDate = doughnutChartStartDate = startDate_29DaysAgo;
      }
      dispatch(setStartDate(moment(barChartStartDate, 'YYYY-MM-DD').toDate()));
      dispatch(setEndDate(lastMatchedCertificateStartDate));

      dispatch(setCardsStartDate(moment(equivalentCardsStartDate, 'YYYY-MM-DD').toDate()));
      dispatch(setCardsEndDate(lastMatchedCertificateStartDate));

      // Get all data to print in parallel
      let parallelReturnedObject = await Promise.all(
        [
          getProducingAssetPercentageForConsumingAssetAndRange(asset, barChartStartDate, barChartEndDate, statusFilterArray),
          getProducingAssetPercentageForConsumingAssetAndRange(asset, lastMatchedDay, lastMatchedDay, statusFilterArray),
          getConsumingAssetFrontEndData(asset, equivalentCardsStartDate, equivalentCardsEndDate, statusFilterArray)
        ]
      );

      // Destructure returned object
      let [
        producingAssetPercentageForRange,
        producingAssetPercentageForLastMatchedDay,
        consumingAssetFrontEndData
      ] = parallelReturnedObject;
      
      dispatch({
        type: ACTION_TYPE.ASSET_CONSUMING.GET_PRODUCING_ASSET_PERCENTAGE_FOR_RANGE_SUCCESS,
        payload: producingAssetPercentageForRange
      });

      dispatch({
        type: ACTION_TYPE.ASSET_CONSUMING.GET_PRODUCING_ASSET_PERCENTAGE_LAST_MATCHED_DAY_SUCCESS,
        payload: { 
          percentageData: producingAssetPercentageForLastMatchedDay,
          lastMatchedDay: lastMatchedDay
        }
      });

      dispatch({
        type: ACTION_TYPE.ASSET_CONSUMING.GET_FRONT_END_DATA_FOR_CONSUMING_ASSET,
        payload: {
          frontEndDataForConsumingAsset: consumingAssetFrontEndData
        }
      });

      const barChartData = await getBarChartData( asset, barChartStartDate, barChartEndDate );
      
      dispatch({
        type: "GET_ASSET_CONSUMING_BARCHARTDATA_SUCCESS",
        payload: barChartData
      });
  
      //Doughnut chart long period (last 12 months or last 30 days)
      let doughnutChartData = await getDoughnutChartData( asset, doughnutChartStartDate, doughnutChartEndDate );
  
      doughnutChartData.percentagesArray = doughnutChartData.percentageOfMatchedEnergyArray.map(prodAssetPercentageAndDetails => {
        return {
          percentage: prodAssetPercentageAndDetails.percentageOfMatchedEnergy,
          asset: prodAssetPercentageAndDetails.producingAsset
        }
      })
  
      doughnutChartData.percentagesArray.push({
        percentage: doughnutChartData.percentageOfEnergyMix,
        asset: {displayedName: ENERGY_MIX_LABEL}
      })
  
      dispatch({
        type: "GET_ASSET_CONSUMING_DOUGHNUTCHARTDATA_SUCCESS",
        payload: doughnutChartData
      });

      return asset;
    } catch (error) {
      console.error(error);
      dispatch({ type: "GET_ASSET_CONSUMING_FAIL", payload: asset });
      dispatch({ type: ACTION_TYPE.MESSAGE_DIALOG.OPEN_ERROR, payload: "Error during fetching data for asset." });
    }
  } else {
    dispatch({ type: "GET_ASSET_CONSUMING_FAIL", payload: asset });
    history.push("/unauthorized");
    return { status: "unauthorized" };
  }
};

export const getAssetConsumingRefresh = (
  assetId,
  history,
  startDate_YYYYMMDD,
  endDate_YYYYMMDD
  ) => async dispatch => {
    const asset = await getAssetConsuming(assetId, history, dispatch);
  
    if (asset) {
      try {
        const producingAssets = await getAssetsProducing();
        asset.producingAssets = asset.producingAssets.map(prodAsset => {
          let prodAssetFull  = producingAssets.find(producingAsset => producingAsset.id === prodAsset.id)
          prodAssetFull.priority = prodAsset.priority;
          prodAssetFull.percentage = prodAsset.percentage;
          return prodAssetFull;
        });
  
        dispatch({ type: "GET_ASSET_CONSUMING_SUCCESS", payload: asset });
  
        let statusFilterArray = DEFAULT_CERTIFICATE_STATUS_FILTER_ARRAY;
  
        let barChartStartDate = startDate_YYYYMMDD;
        let barChartEndDate = endDate_YYYYMMDD;

        let equivalentCardsStartDate = startDate_YYYYMMDD;
        let equivalentCardsEndDate = endDate_YYYYMMDD;

        let doughnutChartStartDate = startDate_YYYYMMDD;
        let doughnutChartEndDate = endDate_YYYYMMDD;
  
        dispatch(setCardsStartDate(moment(equivalentCardsStartDate, 'YYYY-MM-DD').toDate()));
        dispatch(setCardsEndDate(moment(equivalentCardsEndDate, 'YYYY-MM-DD').toDate()))

        // Get all data to print in parallel
        let parallelReturnedObject = await Promise.all(
          [
            getProducingAssetPercentageForConsumingAssetAndRange(asset, barChartStartDate, barChartEndDate, statusFilterArray),
            getConsumingAssetFrontEndData(asset, barChartStartDate, barChartEndDate, statusFilterArray)
          ]
        );
  
        // Destructure returned object
        let [
          producingAssetPercentageForRange,
          consumingAssetFrontEndData
        ] = parallelReturnedObject;
  
        dispatch({
          type: ACTION_TYPE.ASSET_CONSUMING.GET_PRODUCING_ASSET_PERCENTAGE_FOR_RANGE_SUCCESS,
          payload: producingAssetPercentageForRange
        });
  
        dispatch({
          type: ACTION_TYPE.ASSET_CONSUMING.GET_FRONT_END_DATA_FOR_CONSUMING_ASSET,
          payload: {
            frontEndDataForConsumingAsset: consumingAssetFrontEndData
          }
        });
  
        const barChartData = await getBarChartData( asset, barChartStartDate, barChartEndDate );
        
        dispatch({
          type: "GET_ASSET_CONSUMING_BARCHARTDATA_SUCCESS",
          payload: barChartData
        });
    
        //Doughnut chart long period (last 12 months or last 30 days)
        let doughnutChartData = await getDoughnutChartData( asset, doughnutChartStartDate, doughnutChartEndDate );
    
        doughnutChartData.percentagesArray = doughnutChartData.percentageOfMatchedEnergyArray.map(prodAssetPercentageAndDetails => {
          return {
            percentage: prodAssetPercentageAndDetails.percentageOfMatchedEnergy,
            asset: prodAssetPercentageAndDetails.producingAsset
          }
        })
    
        doughnutChartData.percentagesArray.push({
          percentage: doughnutChartData.percentageOfEnergyMix,
          asset: {displayedName: ENERGY_MIX_LABEL}
        })
    
        dispatch({
          type: "GET_ASSET_CONSUMING_DOUGHNUTCHARTDATA_SUCCESS",
          payload: doughnutChartData
        });
  
        return asset;
      } catch (error) {
        console.error(error);
        dispatch({ type: "GET_ASSET_CONSUMING_FAIL", payload: asset });
        dispatch({ type: ACTION_TYPE.MESSAGE_DIALOG.OPEN_ERROR, payload: "Error during fetching data for asset." });
      }
    } else {
      dispatch({ type: "GET_ASSET_CONSUMING_FAIL", payload: asset });
      history.push("/unauthorized");
      return { status: "unauthorized" };
    }
  };

export const getProducingAssetPercentageForConsumingAssetAndRange = async(consumingAsset, startDate, endDate, statusFilterArray) => {
  const GET_PRODUCING_ASSET_PERCENTAGE_URL = makeCompleteUrlFromLastPart("/api/graph-data/percentage-matched-for-consuming-asset");
  
  let frequency = getConsumingAssetFrequency(consumingAsset)

  let body = {
    consumingAssetObjectId: consumingAsset._id,
    startDate,
    endDate,
    statusFilterArray,
    frequency
  }

  let producingAssetPercentageForConsumingAssetAndRange = await postJsonRequest(GET_PRODUCING_ASSET_PERCENTAGE_URL, body);
  return producingAssetPercentageForConsumingAssetAndRange;
}

export const getLastMatchedStartDateForConsumingAsset = async (consumingAsset, statusFilterArray) => {
  const GET_LAST_MATCHED_DAY_FOR_CONSUMING_ASSET_URL = makeCompleteUrlFromLastPart("/api/consum/last-matched-day-for-consuming-asset");
  
  let frequency = getConsumingAssetFrequency(consumingAsset)

  let body = {
    assetID: consumingAsset.assetID,
    statusFilterArray: statusFilterArray,
    certificateFrequencyFilter: frequency
  }

  let lastMatchedStartDateForConsumingAsset = await postJsonRequest(GET_LAST_MATCHED_DAY_FOR_CONSUMING_ASSET_URL, body);

  return lastMatchedStartDateForConsumingAsset.lastMatchedDay;
}

export const computeAverageDistanceInMeters = (consumingAsset, producingAssetArray, producingAssetPercentageArray) => {
  let averageDistanceInMeters = 0;

  //To calculate the average distance, we first get the distance between the consuming asset and each production asset :
  const currentAssetConsuming = consumingAsset;
  const producingAssets = producingAssetArray;

  if (
    !(producingAssets && producingAssets.length > 0) ||
    !currentAssetConsuming ||
    !producingAssets
  ) {
    throw new Error(`Cannot compute average distance because no producing assets or consuming asset provided.`);
  }

  const assetConsumingLatLng = {
    lat: parseFloat(currentAssetConsuming.gpsLatitude),
    lng: parseFloat(currentAssetConsuming.gpsLongitude)
  };

  let totalRatio = producingAssetPercentageArray
    .map(p => p.percentageOfMatchedEnergy)
    .reduce((a, b) => { return a + b; })


  let distanceArray = []

  // Convert to % without energy mix
  for(let producingAssetPercentageItem of producingAssetPercentageArray) {
    let percentageOfTotalMatchedEnergy = producingAssetPercentageItem.percentageOfMatchedEnergy / totalRatio;

    const assetLatLng = {
      lat: parseFloat(producingAssetPercentageItem.producingAsset.gpsLatitude),
      lng: parseFloat(producingAssetPercentageItem.producingAsset.gpsLongitude)
    };

    let distanceInMeters = getDistanceInMeters(
      assetConsumingLatLng,
      assetLatLng
    );

    averageDistanceInMeters += (distanceInMeters * percentageOfTotalMatchedEnergy);

    distanceArray.push({
      assetId: producingAssetPercentageItem.producingAsset.id,
      percentage: percentageOfTotalMatchedEnergy,
      distance: distanceInMeters
    })
  }

  return averageDistanceInMeters;
}


// WEBPACK FOOTER //
// ./src/actions/AssetsConsumingActions.js